import classNames from "classnames";
import React, { FC, useEffect, useState } from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { useAppContext } from "../Contexts/AppContext";
import { searchTitle } from "../Forms/Drawing/Search";
import { useDrawingContext } from "../Contexts/DrawingContext";
import "./Accordion.scss";

export const Accordion: FC<{ maxHeight: number }> = (props) => (
    <div className="accordion" style={{ maxHeight: props.maxHeight + "px" }}>
        {props.children}
    </div>
);

export const AccordionItem: FC<{
    title: string;
    defaultExpanded?: number;
    changeHeight?: number;
    nonExpandable?: boolean;
    class?: string;
}> = (props) => {
    const { isMobile } = useAppContext();
    const { setSearchInfoVisible } = useRegistrationContext();

    const contentMarginHeight = isMobile && props.title === searchTitle ? 28 : 8;
    let headerHeight = props.nonExpandable ? 0 : 40; // same as in css

    const [expanded, setExpanded] = useState<number>(props.defaultExpanded || 0);
    const [contentHeight, setContentHeight] = useState<number>(0);
    const [height, setHeight] = useState<number>(headerHeight);

    if (isMobile && !expanded && props.title === searchTitle) {
        headerHeight = 60;
    }

    const onClick = () => {
        setExpanded(expanded ? 0 : Math.random());
        setSearchInfoVisible(false);
    };

    useEffect(() => {
        const content = document.getElementById(props.title);
        content && setContentHeight(content.scrollHeight);
    }, []);

    useEffect(() => {
        setExpanded(props.defaultExpanded || 0);
    }, [props.defaultExpanded]);

    useEffect(() => {
        setTimeout(() => {
            const content = document.getElementById(props.title);
            content && setContentHeight(content.scrollHeight);
        }, 0);
    }, [props.changeHeight]);

    useEffect(() => {
        expanded ? setHeight(headerHeight + contentHeight + contentMarginHeight) : setHeight(headerHeight);
    }, [expanded, contentHeight]);

    const style = { height: height + "px" };

    // <span className="icon-geo-minus static"></span> is workaround for iOS, to render and redraw correct

    return (
        <div className={"accordion-item " + props.class} style={style}>
            {!props.nonExpandable && (
                <div className="accordion-item-header" onClick={onClick}>
                    <div className="item-title">{props.title}</div>
                    <div className={classNames("item-icon", { minus: expanded })}>
                        <span className="icon-geo-minus first"></span>
                        <span className="icon-geo-minus second"></span>
                    </div>
                </div>
            )}
            <div id={props.title} className={"accordion-item-content"}>
                {props.children}
            </div>
        </div>
    );
};
